export default __webpack_public_path__ + "static/media/30.826d7c3b.png";